import Crown from "../../assets/images/fi-rr-crown-black.svg";
import User from "../../assets/images/fi-rr-user.svg";
import DisabledPerson from "../../assets/images/disabled-person-black.svg";
import Laptop from "../../assets/images/fi-rr-laptop.svg";
import Skills from "../../assets/images/Skills.png";

import "../../css/jobs.css";

function JobSummaryMap(props: any) {
  const { data } = props;
  return (
    <>
      <div className="map-container__divs">
        <div className="divs__svgs">
          <img src={Laptop} alt="Laptop" />
        </div>
        <div className="divs__text-n-steps">
          <p>People from</p>
          {/* <h3>{`${CreatedJobDetails?.categoryId?.name}`}</h3> */}
          <h3>{data?.industry ?? ""}</h3>
        </div>
      </div>
      <div className="map-container__divs">
        <div className="divs__svgs">
          <img src={Crown} alt="Crown" />
        </div>
        <div className="divs__text-n-steps">
          <p>Specializes in</p>
          {/* <h3>{`${CreatedJobDetails?.sepeclityId?.name}`}</h3> */}
          <h3>{data?.profession ?? ""}</h3>
        </div>
      </div>
      <div className="map-container__divs">
        <div className="divs__svgs">
          <img src={User} alt="User" />
        </div>
        <div className="divs__text-n-steps">
          <p>To fill our</p>
          {/* <h3>{`${CreatedJobDetails?.jobtitle}`}</h3> */}
          <h3>{data?.companyJob?.jobTitle ?? ""}</h3>
        </div>
      </div>
      <div className="map-container__divs" style={{paddingBottom:10,}} > 
        <div className="divs__svgs">
          <img src={Skills} alt="User" style={{width:18,height:18}}/>
        </div>
        <div className="divs__text-n-steps" style={{marginLeft:16}} >
          <p>Skills required are</p>
          <div style={{display:'flex',width:"100%",flexWrap:'wrap',marginTop:15}}>
          {data?.skills?.map((item:any)=>(
          <div style={{backgroundColor:'#E0E0E0',marginRight:12,borderRadius:6,marginBottom:6,textAlign:'center',width:90,border:'0.5px solid black'}}><h4 style={{wordBreak:'break-word',marginTop:4}}>{item?.skillName}{" "}</h4></div>
          ))}
          </div>
        </div>
      </div>
      {/* {CreatedJobDetails?.isDisabled&& <div className="map-container__divs"> */}
      {data?.isDisable && (
        <div className="map-container__divs">
          <div className="divs__svgs">
            <img src={DisabledPerson} alt="Disabled-Person" />
          </div>
          <div className="divs__text-n-steps">
            <p>Can be</p>
            <h3>Differently-abled</h3>
          </div>
        </div>
      )}
    </>
  );
}

export default JobSummaryMap;
